<template>
  <div class="tickets-container">
    <p class="tickets-container-title">Tickets</p>
    <div v-if="parter.length" class="tickets-wrapper">
      <p class="ticket-type">Parter tickets</p>
      <v-btn
        v-for="(ticket, index) in parter"
        :key="index"
        class="ticket"
        :disabled="handleDisableTicketButton(ticket, 'parter')"
        :style="
          isTicketSelected(ticket.id) && `border:  ${ticket.color} solid 1px; background: white`
        "
        @click="selectedSeats.length && $emit('handleConnectSeatWithTicket', ticket)"
      >
        <div class="ticket-color" :style="'background:' + ticket.color" />
        <p
          class="ticket-name"
          :style="isTicketSelected(ticket.id) && `color: ${ticket.color} !important`"
        >
          {{ ticket.name }}
        </p>
        <p class="ticket-count">{{ countPerTicket[ticket.id] }}</p>
        <p class="ticket-price">{{ Number(ticket.price).toFixed(2) }}€</p>
        <span v-if="!handleDisableTicketButton(ticket, 'parter')" class="material-icons">
          {{ isTicketSelected(ticket.id) ? 'link_off' : 'link' }}
        </span>
      </v-btn>
    </div>
    <hr v-if="parter.length" class="hr-style" />
    <div v-if="regular.length" class="tickets-wrapper">
      <p class="ticket-type">Seating tickets</p>
      <v-btn
        v-for="(ticket, index) in regular"
        :key="index"
        class="ticket"
        :disabled="handleDisableTicketButton(ticket, 'regular')"
        :style="
          isTicketSelected(ticket.id) && `border:  ${ticket.color} solid 1px; background: white`
        "
        @click="selectedSeats.length && $emit('handleConnectSeatWithTicket', ticket)"
      >
        <div class="ticket-color" :style="'background:' + ticket.color" />
        <p
          class="ticket-name"
          :style="isTicketSelected(ticket.id) && `color: ${ticket.color} !important`"
        >
          {{ ticket.name }}
        </p>
        <p class="ticket-count">{{ countPerTicket[ticket.id] }}</p>
        <p class="ticket-price">{{ Number(ticket.price).toFixed(2) }}€</p>
        <span v-if="!handleDisableTicketButton(ticket, 'regular')" class="material-icons">
          {{ isTicketSelected(ticket.id) ? 'link_off' : 'link' }}
        </span>
      </v-btn>
    </div>
    <hr v-if="regular.length" class="hr-style" />
    <div v-if="table.length" class="tickets-wrapper">
      <p class="ticket-type">Table tickets</p>
      <v-btn
        v-for="(ticket, index) in table"
        :key="index"
        class="ticket"
        :disabled="handleDisableTicketButton(ticket, 'table')"
        :style="
          isTicketSelected(ticket.id) && `border:  ${ticket.color} solid 1px; background: white`
        "
        @click="selectedSeats.length && $emit('handleConnectSeatWithTicket', ticket)"
      >
        <div class="ticket-color" :style="'background:' + ticket.color" />
        <p
          class="ticket-name"
          :style="isTicketSelected(ticket.id) && `color: ${ticket.color} !important`"
        >
          {{ ticket.name }}
        </p>
        <p class="ticket-count">{{ countPerTicket[ticket.id] }}</p>
        <p class="ticket-price">{{ Number(ticket.price).toFixed(2) }}€</p>
        <span v-if="!handleDisableTicketButton(ticket, 'table')" class="material-icons">
          {{ isTicketSelected(ticket.id) ? 'link_off' : 'link' }}
        </span>
      </v-btn>
    </div>
    <hr v-if="table.length" class="hr-style" />
    <div class="tickets-wrapper">
      <p class="ticket-type">Additional</p>
      <div class="seat-state-wrapper">
        <div
          class="seat-state"
          :style="currSelectedSeatState === 2 && 'border: #0277BD solid 1px; background: white'"
          @click="
            selectedSeats.length &&
              (currSelectedSeatState = 2) &&
              $emit('handleSeatAvailability', SeatState.DISABLED)
          "
        >
          <span class="unavailable-circle" />
          <p class="ticket-name" :style="currSelectedSeatState === 2 && 'color:#0277BD;'">
            Unavailable
          </p>
        </div>
        <div class="seat-state" style="cursor: default">
          <span class="booked-sold-circle" />
          <p class="ticket-name">Booked/Sold</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment/moment'
import { SeatState, TicketType } from '@/types'

export default {
  name: 'floor-plan-ticket-view',
  props: {
    initRegular: {
      type: Array,
      default: () => [],
    },
    initParter: {
      type: Array,
      default: () => [],
    },
    initTable: {
      type: Array,
      default: () => [],
    },
    selectedTicket: null,
    svgElementType: String,
    selectedSeats: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      regular: this.initRegular,
      parter: this.initParter,
      table: this.initTable,
      SeatState: SeatState,
      currSelectedSeatState: 0,
      countPerTicket: {},
    }
  },
  mounted() {
    this.setCountPerTicket()
  },
  methods: {
    isTicketSelected(id) {
      return (
        this.selectedTicket &&
        this.selectedTicket.length &&
        this.selectedTicket.find(st => st.id === id)
      )
    },
    setCountPerTicket() {
      const newTicketCount = {}
      for (const type of Object.values(TicketType)) {
        this[type].map(oi => {
          newTicketCount[oi.id] = oi.sectionSeats.length
        })
      }

      return (this.countPerTicket = newTicketCount)
    },
    resetCurrSelectedSeatState() {
      this.currSelectedSeatState = 0
    },
    handleDisableTicketButton(ticket, ticketType) {
      if (ticketType !== this.svgElementType) {
        return true
      }
      const selectableTickets =
        (this.selectedTicket.length &&
          this[this.svgElementType].filter(
            oi =>
              moment(oi.from).isAfter(this.selectedTicket[0].to) ||
              moment(oi.to).isBefore(this.selectedTicket[0].from),
          )) ||
        []

      return (
        !this.selectedSeats.length ||
        (this.selectedTicket.length === 2 &&
          !this.selectedTicket.find(st => st.id.includes(ticket.id))) ||
        (!!this.selectedTicket.length &&
          !this.selectedTicket.find(st => st.id.includes(ticket.id)) &&
          !selectableTickets.find(st => st.id === ticket.id))
      )
    },
  },
}
</script>
<style scoped>
p {
  margin-bottom: 0;
}
.tickets-container-title {
  background: #f5f5f5;
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 1.25rem;
  padding: 16px 24px;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #0277bd;
  border-radius: 8px 8px 0 0;
}

.ticket {
  width: 100%;
  background: #f5f5f5 !important;
  cursor: pointer;
  height: fit-content !important;
  border: 1px solid #d9d9d9;
  border-radius: 1000px;
  display: flex;
  margin: 0 !important;
  padding: 0 !important;
  box-shadow: none !important;
}

.seat-state {
  width: fit-content;
  min-height: 1.7rem;
  cursor: pointer;
  border: 1px solid #d9d9d9;
  border-radius: 1000px;
  align-items: center;
  display: flex;
  padding: 0 !important;
  box-shadow: none !important;
}

.ticket-name {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 0.875rem;
  text-align: center;
  padding: 0 8px;
  color: #979797;
}

.tickets-wrapper {
  display: flex;
  row-gap: 8px;
  flex-direction: column;
  padding: 16px 24px;
}

.hr-style {
  height: 1px;
  background: #d9d9d9;
  border-radius: 2px;
}

v-btn >>> .v-btn__content {
  display: flex;
  flex-direction: column;
}

.seat-state-wrapper {
  display: flex;
  gap: 0.5rem;
}

.ticket-color {
  width: 12px;
  height: 12px;
  border-radius: 1000px;
}
@media screen and (max-width: 1331px) {
  .tickets-container {
    max-width: 42.75rem !important;
    margin-top: 1.5rem;
  }
}

.unavailable-circle {
  display: inline-block;
  margin-left: 0.5rem;
  height: 0.75rem;
  width: 0.75rem;
  border-radius: 62.5rem;
  background: #d9d9d9;
}

.ticket-type {
  color: #666;
  font-family: 'Raleway';
  font-weight: 600;
  font-size: 1rem;
}

.tickets-container {
  max-width: 24.125rem;
  min-height: 16.0625rem;
  border: #d9d9d9 solid 1px;
  border-radius: 8px;
}
.booked-sold-circle {
  display: inline-block;
  margin-left: 0.5rem;
  height: 0.75rem;
  width: 0.75rem;
  border-radius: 62.5rem;
  background: #f5f5f5;
  border: 1px solid #d9d9d9;
}
.ticket-price {
  margin-right: 8px;
}
.ticket-count {
  height: 18px;
  min-width: 18px;
  background: #0277bd;
  font-family: 'Source Sans Pro';
  text-align: center;
  vertical-align: center;
  color: white;
  line-height: normal;
  margin-right: 8px;
}
</style>
